<template>
  <div v-show="panelShow">
    <Col :xs="24" :sm="24" :md="24" :lg="colSpan" :style="{padding: '5px'}">
      <Card shadow style="height: 200px; max-height: 160px" class="home-card">
        <div slot="title"><font-awesome-icon icon="server" /><b> 主机概览</b></div>
        <Alert type="warning" show-icon v-if="error">获取主机数据失败</Alert>
        <Spin fix v-else-if="loading" class="home-component-loading">
          <Icon type="ios-loading" size=18 class="demo-spin-icon-load"></Icon>
          <div>加载中</div>
        </Spin>
        <div v-else>
          <Row>
            <Col :span="6">
              <div style="text-align: center">
                <p>总数量</p>
                <span style="color: #2d8cf0; font-size: 35px"><count-to :end="count.total" count-class="count-style" /></span>
              </div>
            </Col>
            <Col :span="6">
              <div style="text-align: center">
                <p>运行中</p>
                <span style="color: #19be6b; font-size: 35px;"><count-to :end="count.run" count-class="count-style" /></span>
              </div>
            </Col>
            <Col :span="6">
              <div style="text-align: center">
                <p>即将过期</p>
                <span style="color: #ff9900; font-size: 35px"><count-to :end="count.expired_at_once" count-class="count-style" /></span>
              </div>
            </Col>
            <Col :span="6">
              <div style="text-align: center">
                <p>已过期</p>
                <span style="color: #ed4014; font-size: 35px"><count-to :end="count.expired" count-class="count-style" /></span>
              </div>
            </Col>
          </Row>
        </div>
      </Card>
    </Col>
  </div>
</template>

<script>
import { getServerAmount } from '@/api/opscenter'
import CountTo from '_c/count-to'

export default {
  name: 'server-count',
  components: {
    CountTo
  },
  props: {
    panelShow: {
      type: Boolean,
      default: true
    },
    colSpan: {
      type: Number,
      default: 8
    }
  },
  data () {
    return {
      count: {
        total: 0,
        run: 0,
        expired_at_once: 0,
        expired: 0
      },
      error: false,
      loading: false
    }
  },
  watch: {
    panelShow () {
      if (this.panelShow) {
        this.getServerAmountData()
      }
    }
  },
  created: function () {
    if (this.panelShow) {
      this.getServerAmountData()
    }
  },
  methods: {
    getServerAmountData () {
      this.loading = true
      getServerAmount().then(res => {
        this.loading = false
        const result = res.data
        if (result.code === 200) {
          this.count = result.data
        } else {
          this.error = true
        }
      }).catch(res => {
        this.loading = false
        this.error = true
      })
    }
  }
}
</script>

<style scoped>
  .demo-spin-icon-load {
    animation: ani-demo-spin 1s linear infinite;
  }
</style>
